import React, { useEffect, useRef, useState } from "react";

const SquarePayment = ({
  parentFirstName,
  parentLastName,
  parentEmail,
  parentPhone,
  onTokenReceived
}) => {

  const [tokenReceived, setTokenReceived] = useState(false);
  const parentDataRef = useRef({});

  // Update ref whenever parent values change
  parentDataRef.current = {
    parentFirstName,
    parentLastName,
    parentEmail,
    parentPhone
  };

  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    const loadScript = () =>
      new Promise((resolve, reject) => {
        if (window.Square) return resolve();
        const s = document.createElement("script");
        s.src = "https://web.squarecdn.com/v1/square.js";
        s.onload = resolve;
        s.onerror = reject;
        document.head.appendChild(s);
      });

    const init = async () => {
      await loadScript();

      const payments = window.Square.payments(
        "sq0idp-J_50cO2rPmqtHayFIhDFMg",
        "LRKWDN6N96DHH"
      );

      const card = await payments.card();
      await card.attach("#card-container");

      document.getElementById("pay-button")
        .addEventListener("click", async () => {

          const result = await card.tokenize();

          if (result.status === "OK") {

            const { parentFirstName, parentLastName, parentEmail, parentPhone } =
              parentDataRef.current;

            setTokenReceived(true);
            //onTokenReceived(token);
            onTokenReceived({
              token: result.token,
              firstName: parentFirstName,
              lastName: parentLastName,
              email: parentEmail,
              phone: parentPhone
            });
            /*props.onTokenReceived({
              token: token,
              parentInfo: {
                firstName: props.parentFirstName,
                lastName: props.parentLastName,
                email: props.parentEmail,
                phone: props.parentPhone
              },
              cart: props.cart  // send latest cart to parent
            });*/

          } else {
            alert("Payment failed: " + result.errors?.[0]?.message);
          }
        });
    };

    init();
  }, []);

  return (
    <div>
      <div id="card-container"></div>
      {!tokenReceived && (
        <button id="pay-button" type="button" className="btn btn-primary mt-3 w-100">
          Pay Now
        </button>
      )}
    </div>
  );
};

export default SquarePayment;
